import React, { useEffect, useState } from 'react';
import { Input, notification } from 'antd';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { useLanguage } from '../context/LanguageContext';
import { getVerifyRoomNo } from '../services/apiservice';
import { IS_TABLE_NO_IN_URL, TABLE_NO } from '../constants';

const VerifyRoomTable = (props) => {
    const { setVerifiedTableNumber } = props;
    const [isTableNoInUrl, setIsTableNoInUrl] = useState(true);
    const [tableNumber, setTableNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [api, contextHolder] = notification.useNotification();

    const { t } = useLanguage();

    useEffect(() => {
        const room = localStorage.getItem(TABLE_NO);
        const v = localStorage.getItem(IS_TABLE_NO_IN_URL);
        setIsTableNoInUrl(v === '1');
        if (room) {
            setTableNumber(room);
            setVerifiedTableNumber(room);
        }
    }, []);

    const roomChangeHandler = async (value) => {
        try {
            setLoading(true);
            const response = await getVerifyRoomNo(value);
            if (response.status === 200) {
                localStorage.setItem('table', value);
                setTableNumber(value);
                setVerifiedTableNumber(value);
                api.open({
                    description: 'Table verified successfully!',
                    icon: <CheckCircleFilled style={{ color: '#136c2e' }} />,
                });
            }
        } catch (error) {
            localStorage.removeItem('table', '');
            setTableNumber('');
            setVerifiedTableNumber('');
            setError(t['valid_room_no_msg']);
            setTimeout(() => {
                setError('');
            }, 2000);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {contextHolder}
            <div className={'flex  justify-between items-center gap-2'}>
                <label className={'flex-1'}>{t['room_villa_no']}</label>
                {!isTableNoInUrl ? (
                    <div className='flex flex-col'>
                        <Input
                            onBlur={(e) => roomChangeHandler(e.target.value)}
                            placeholder={t['room_villa_no']}
                            onChange={(e) => setTableNumber(e.target.value)}
                            value={tableNumber}
                            className='roomNumberInput flex-1 w-44'
                            suffix={loading ? <LoadingOutlined /> : ''}
                        />
                        {error && (
                            <p className='text-red-400'>
                                <small>{error}</small>
                            </p>
                        )}
                    </div>
                ) : (
                    <label>{tableNumber}</label>
                )}
            </div>
        </>
    );
};

export default VerifyRoomTable;
